// location = chandigarh
export const CORS_URL = 'https://corsproxy.io/?'

export const IMG_URL_CDN =
  'https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_850,h_504/'

export const RESTAURENT_DESKTOP_API_URL =
  'https://www.swiggy.com/dapi/restaurants/list/v5?lat=30.7333148&lng=76.7794179&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING'

export const RESTAURENT_MOBILE_API_URL =
  'https://www.swiggy.com/mapi/homepage/getCards?lat=30.7333148&lng=76.7794179'

export const DESTKTOP_MENU_API =
  'https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.9873139&lng=77.04451030000001&restaurantId='

export const MOBILE_MENU_API =
  'https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=30.7333148&lng=76.7794179&restaurantId='

export const RESTAURANT_OFFER_API =
  'https://corsproxy.io/?https://www.swiggy.com/dapi/offers/restaurant?lat=30.7333148&lng=76.7794179&offset=0'

export const PAYMENT_OFFER_API =
  'https://corsproxy.io/?https://www.swiggy.com/dapi/offers/payment?lat=30.7333148&lng=76.7794179&offset=0'
